<template>
  <v-card class="pa-2 ma-2" :href="gear.link" target="_blank">
    <v-img :src="src" height="180px" />
    <h5 class="mt-2 font-weight-light">{{ gear.name }}</h5>
  </v-card>
</template>

<script>
export default {
  name: 'LegacyGearCard',
  props: {
    gear: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    src() {
      return this.gear.image_optimized
        ? `${this.$config.staticUrl}${this.gear.image_optimized}`
        : require('../../assets/images/happyly_logo_placeholder.png')
    },
  },
}
</script>
